import {Component, Input, OnInit, ViewChild, ElementRef, HostListener, Output, EventEmitter} from '@angular/core';
import {GameSetUpService} from '../../providers/gameSetUp.service';
import {FinishListService} from '../../providers/finishList.service';



@Component({
    selector: 'team-component',
    templateUrl: './team.component.html',
    styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {

    @ViewChild('scoreDummy')scoreDummy: ElementRef;
    @ViewChild('scoreList')scoreList: ElementRef;
    @ViewChild('teamContainer')teamContainer: ElementRef;
    @HostListener('window:resize') onResize() {
        setTimeout(_ => this.setScoreListHeight() );

    }
    @Output() editScore = new EventEmitter();

    @Input() teamData: any;
    @Input() active: boolean;

    @Input() size: string = 'big';
    public listFull: boolean = false;
    public scoreListHeight = null;

    public teamReady: boolean = false;

    public previousScoreListLength: number = 0;

    constructor(public gameSetUpService: GameSetUpService, public finishListService: FinishListService) {
    }

    ngOnInit() {
        console.log('teamData:', this.teamData);
    }


    ngAfterViewInit() {
        setTimeout(_ => this.setScoreListHeight() );
        this.teamReady = true;
    }

    setScoreListHeight() {


        let scoreListBoundings = this.scoreList.nativeElement.getBoundingClientRect();
        let scoreDummyBoundings = this.scoreDummy.nativeElement.getBoundingClientRect();
        let teamContainerBoundings = this.teamContainer.nativeElement.getBoundingClientRect();

        let maxScoreListHeight = teamContainerBoundings.height - (scoreListBoundings.top - teamContainerBoundings.top);
        let optimalScoreListHeight = Math.floor(maxScoreListHeight / scoreDummyBoundings.height) * scoreDummyBoundings.height;

        this.scoreListHeight = Math.round(optimalScoreListHeight);

    }

    ngOnChanges(event) {

        if (this.teamData.scores.length !== this.previousScoreListLength) {
            this.previousScoreListLength = this.teamData.scores.length;
            if (this.teamReady) {
                setTimeout(_ => this.setScoreListHeight() );
            }
        }

    }




    calcAverage() {
        let sum = this.teamData.scores.reduce(function(pv, cv) { return pv + cv; }, 0);
        return Math.round(sum / this.teamData.scores.filter(function(value) { return value !== null }).length);
    }

    calcPoints() {
        if (this.gameSetUpService.gameMode === 'X01') {
            let sum = this.teamData.scores.reduce(function(pv, cv) { return pv + cv; }, 0);
            return this.teamData.points - sum;
        }
        if (this.gameSetUpService.gameMode === 'count-up') {
            let sum = this.teamData.scores.reduce(function(pv, cv) { return pv + cv; }, 0);
            return sum;
        }
    }

    getWayToFinish() {
        let points = this.calcPoints();
        if (points <= 170 && this.teamData.finishing === 'doubleOut' && this.gameSetUpService.gameMode === 'X01') {
            return this.finishListService.doubleOut[points];
        } else {
            return null;
        }
    }


    onEditScore(scoreIndex) {
        console.log(this.teamData.scores[scoreIndex]);
        // this.teamData.scores[scoreIndex] = 20;
        this.editScore.emit({scoreIndex: scoreIndex, teamData: this.teamData});
    }

}



// WEBPACK FOOTER //
// ./src/app/components/team/team.component.ts